var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { KeyBoardKeys } from "../../../../types";
import { useTheme } from "styled-components";
import { Button } from "../../../../button";
import { AspectRatio } from "../../../../aspect-ratio";
import { ImageWithHeadlineContainer, ImageContainer, TitleContainer, } from "./ImageWithHeadline.styles";
import { StyledTypo } from "../common/Common.styles";
import { Image } from "../image/image";
// utils
import { makeDataTestIdGetter } from "../../../../utils";
const breakpointsRatioMap = {
    small: "2:3",
    medium: "16:9",
    large: "16:9",
    xlarge: "16:9",
};
export function Tlea1(_a) {
    var { title, subTitle, image, imageTitle, headlineVariant, altText, gap, backgroundType, emphasize, button, breakPoint, imageAspectRatios = {}, fallbackImg, backgroundColor, titlePreviewId = "#st_title", subtitlePreviewId = "#st_subtitle", dataTestIdPrefix } = _a, rest = __rest(_a, ["title", "subTitle", "image", "imageTitle", "headlineVariant", "altText", "gap", "backgroundType", "emphasize", "button", "breakPoint", "imageAspectRatios", "fallbackImg", "backgroundColor", "titlePreviewId", "subtitlePreviewId", "dataTestIdPrefix"]);
    const theme = useTheme();
    const [focused, setFocused] = useState(false);
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    function mergeObjects(A, B) {
        const res = {};
        Object.keys(Object.assign(Object.assign({}, A), B)).forEach((key) => {
            res[key] = B[key] || A[key];
        });
        return res;
    }
    function renderImageContainer() {
        if (image) {
            const ratios = mergeObjects(breakpointsRatioMap, imageAspectRatios);
            return (_jsx(AspectRatio, Object.assign({ ratio: ratios[breakPoint] }, { children: _jsx(ImageContainer, Object.assign({ className: "image-container" }, { children: _jsx(Image, { title: imageTitle, alt: altText, src: image, fallbackSrc: fallbackImg, fallbackBackgroundColor: backgroundColor }) })) })));
        }
        return null;
    }
    return (_jsxs(ImageWithHeadlineContainer, Object.assign({ gap: gap, onMouseDown: () => setFocused(false), onKeyUp: (e) => {
            if (e.key === KeyBoardKeys.Tab) {
                setFocused(true);
            }
        }, onBlur: () => setFocused(false), focused: focused, size: "l", tabIndex: 0, "data-testid": getDataTestId("image-with-headline-input") }, rest, { children: [renderImageContainer(), _jsxs(TitleContainer, Object.assign({ backgroundType: backgroundType, withButton: Boolean(button) }, { children: [_jsx(StyledTypo, Object.assign({ backgroundtype: backgroundType, variant: headlineVariant, fontWeight: emphasize === "title"
                            ? theme.fontWeights.medium
                            : theme.fontWeights.normal, isUppercase: true }, { children: _jsxs(_Fragment, { children: [rest.previewId && rest.isPreview ? (_jsx("span", Object.assign({ "data-preview-id": titlePreviewId }, { children: title }))) : (title), _jsx(StyledTypo, Object.assign({ backgroundtype: backgroundType, tag: "span", size: {
                                        xsmall: theme.fontTokens.font07,
                                        medium: theme.fontTokens.font06,
                                        large: theme.fontTokens.font05,
                                        xlarge: theme.fontTokens.font04,
                                    }, fontWeight: emphasize === "subTitle"
                                        ? theme.fontWeights.medium
                                        : theme.fontWeights.normal, isUppercase: true }, (rest.previewId && rest.isPreview
                                    ? { "data-preview-id": subtitlePreviewId }
                                    : {}), { children: subTitle }))] }) })), button && (_jsx(Button, Object.assign({}, button, { stylingType: backgroundType === "light" ? "secondary" : "secondaryInverted" }, { children: button.text })))] })), _jsx("div", { className: "focus-layer" })] })));
}
